export default {
  app: {
    languagePopup: {
      title: 'Vous êtes actuellement sur la version anglaise de {logo}',
      subtitle: 'Souhaitez-vous passer à votre langue préférée ?',
      cta: 'Passer à {lang}',
    },
  },
};
